module.exports = __webpack_public_path__ + "static/img/101863.566c3fa8.png";